import { Rout_setBack } from './Rout.back'
import { Rout_create } from './Rout.create'
import { Rout_replace, Rout_to } from './Rout'
import type { ReportId as FlowReportId } from '../../../shared/domain/flows/types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { FlowContinuationId } from '../../../app-core/lib/flow/FlowReport'
import type { Post_TPostId } from '../Post/Post.TPost'
import type { Flow_HandleBackOptions } from '../Flow/Flow.handleBack'

export interface Rout_ToDoRoutesArgs {
    Todo_ToDoPage: React.FunctionComponent<unknown>
    Todo_CurrentReportSummary: React.FunctionComponent<unknown>
    Todo_OpenFlowReportSummary: React.FunctionComponent<unknown>
    Todo_ScheduledReportSummary: React.FunctionComponent<unknown>
    Todo_AdHocReportStart: React.FunctionComponent<unknown>
    Todo_AdHocReportSummary: React.FunctionComponent<unknown>
    Todo_AdHocReportSubjectPicker: React.FunctionComponent<unknown>
}

export const Rout_ToDoRoutes = (args: Rout_ToDoRoutesArgs) => [
    Rout_create('/todo', args.Todo_ToDoPage),
    Rout_create('/todo/item-completed', args.Todo_ToDoPage),
    Rout_create('/todo/current', args.Todo_CurrentReportSummary),
    Rout_create('/todo/open-flow/:reportId', args.Todo_OpenFlowReportSummary),
    Rout_create('/todo/start/:procedure/:workflow', args.Todo_AdHocReportStart),
    Rout_create('/todo/:scheduledInstanceId', args.Todo_ScheduledReportSummary),
    Rout_create('/todo/adhoc/:procedure/:workflow', args.Todo_AdHocReportSubjectPicker),
]

export function Rout_toTodo() {
    Rout_to('/todo')
}

export function Rout_replaceToTodo() {
    Rout_replace('/todo')
}

export function Rout_toCurrentReportSummary() {
    Rout_to('/todo/current')
}

export function Rout_toOpenFlowReportSummary(
    reportId: FlowReportId,
    opts?: {
        comingFromActionScheduledInstance?: boolean
        comingFromScheduledInstance?: UUID
        comingFromUnit?: number
        comingFromWorkflow?: number
        comingFromProfileTrainings?: boolean
    }
) {
    Rout_to(`/todo/open-flow/${reportId}`, opts)
}

export function Rout_toScheduledInstanceSummary(
    scheduledInstanceId: string,
    opts?: {
        teamId?: number
        markNotficationsAsRead?: boolean
        comingFromProfileTrainings?: boolean
    }
) {
    Rout_to(`/todo/${scheduledInstanceId}`, opts)
}

export function Rout_toAdHocStart(
    procedure: number,
    workflow: number,
    opts?: { unit?: number; previousReport?: FlowContinuationId },
    back?: () => void
) {
    Rout_setBack(back)
    Rout_to(`/todo/start/${procedure}/${workflow}`, opts)
}

export function Rout_toAdHocSummary(
    procedure: number,
    workflow: number,
    opts?: { unit?: number; previousReport?: FlowContinuationId }
) {
    Rout_to(`/todo/adhoc/${procedure}/${workflow}`, opts)
}

export function Rout_toItemCompleted(
    type: 'action' | 'task' | 'training',
    scheduledInstanceId?: UUID,
    postId?: Post_TPostId,
    origin?: number,
    procedureId?: number,
    previousReport?: FlowContinuationId,
    opts?: Flow_HandleBackOptions
) {
    Rout_to(`/todo/item-completed`, { type, scheduledInstanceId, origin, postId, procedureId, previousReport, opts })
}
